/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-quotes */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-unstable-nested-components */
/**
 * Home Screen
 * 
 * Main screen displaying list of canteens/restaurants
 * Features:
 * - Responsive grid layout (1-5 columns based on screen size)
 * - Pull-to-refresh to reload data
 * - Cart footer with item count and total
 * - Navigation to individual canteen menu
 * - InteractionManager for smooth initial load
 * 
 * @component
 * @param {Object} navigation - React Navigation object
 */
import React, { useEffect, useState } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  FlatList,
  InteractionManager,
  Platform,
  useWindowDimensions,
  Image,
  RefreshControl,
} from 'react-native';
import { Card, Text } from 'react-native-paper';
import { theme } from '../theme/theme';
import { getNumColumns } from '../services/Utils';
import AnimatedView from '../components/AnimatedView';
import { useDispatch, useSelector } from 'react-redux';
import {
  enableRefreshControl,
  fetchCafe,
} from '../store/cafe.slice';
import { setCanteenInfo } from '../store/canteen.slice';
import CartFooter from '../components/Canteen/CartFooter';
import BackButton from '../components/BackButton';
import { useIsFocused } from '@react-navigation/native';
import HttpLoader from '../components/HttpLoader';

function Home({ navigation }) {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isFocused = useIsFocused() && Platform.OS === 'android';
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const canteens = useSelector(state => state.cafe.canteens);
  const error = useSelector(state => state.cafe.error);
  const status = useSelector(state => state.cafe.status);
  const refreshing = useSelector(state => state.cafe?.refreshing);
  const [numColumns, setNumColumns] = useState(getNumColumns(width));

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
    });
    return () => {
      task.cancel();
    };
  }, []);

  useEffect(() => {
    if (!!interactionCompleted) {
      dispatch(fetchCafe());
    }
  }, [interactionCompleted]);

  useEffect(() => {
    if (interactionCompleted && width) {
      setNumColumns(getNumColumns(width));
    }
  }, [interactionCompleted, width]);

  const gotoCanteen = ({ item }) => {
    dispatch(setCanteenInfo(item));
    navigation.navigate('Canteen', {
      canteen_id: item?.canteen_id,
      canteen_name: item?.canteen_name,
    });
  };

  const renderCounter = ({ item, index }) => {
    return (
      <AnimatedView
        style={[
          { marginVertical: 4, paddingHorizontal: 4 },
          { flexBasis: `${100 / numColumns}%` },
        ]}>
        <Card
          onPress={() => {
            if (!item.canteen_closed) {
              gotoCanteen({ item });
            }
          }}
          elevation={0}
          style={{ backgroundColor: '#ffffff', position: 'relative' }}>
          <Image
            source={
              item?.image
                ? { uri: item?.image }
                : require('../assets/default.jpg')
            }
            style={{
              height: 148,
              maxWidth: '100%',
              resizeMode: 'contain',
              paddingHorizontal: 4,
            }}
          />
          <Card.Title
            title={item?.canteen_name}
            titleNumberOfLines={2}
            titleStyle={{
              fontSize: 14,
              textTransform: 'capitalize',
              textAlign: 'center',
            }}
            style={styles.br6}
            rightStyle={{ paddingHorizontal: 6 }}
          />
          {item?.canteen_closed === true ? (
            <View style={[styles.ribbon, { backgroundColor: 'red' }]}>
              <Text style={{ color: '#ffffff', fontSize: 12 }}>{'Closed'}</Text>
            </View>
          ) : (
            item?.pre_order === true && (
              <View
                style={[
                  styles.ribbon,
                  { backgroundColor: theme.colors.primary },
                ]}>
                <Text style={{ color: '#ffffff', fontSize: 12 }}>
                  {'Pre Order'}
                </Text>
              </View>
            )
          )}
        </Card>
      </AnimatedView>
    );
  };

  const CountersHeaderComponent = () => (
    <View
      style={{
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginVertical: 4,
      }}>
      <Text variant="titleMedium" style={{ paddingHorizontal: 4 }}>
        Counters
      </Text>
    </View>
  );

  const renderItem = ({ item, index }) => renderCounter({ item, index });

  const ListHeaderComponent = (
    <React.Fragment>
      {canteens.length > 0 && CountersHeaderComponent()}
    </React.Fragment>
  );

  const _refreshControl = () => {
    return (
      <RefreshControl
        colors={[theme.colors.primary]}
        refreshing={refreshing}
        onRefresh={() => _onRefresh()}
      />
    );
  };

  const _onRefresh = retry => {
    dispatch(enableRefreshControl({ retry }));
    dispatch(fetchCafe());
  };

  return (
    <SafeAreaView edges={['bottom']} style={styles.container}>
      {interactionCompleted && (
        <React.Fragment>
          <HttpLoader status={status} errorHandler={_onRefresh} error={error} />
          {status === 'succeeded' && (
            <React.Fragment>
              <View style={styles.mainContainer}>
                <FlatList
                  ListHeaderComponent={ListHeaderComponent}
                  data={canteens}
                  key={numColumns}
                  numColumns={numColumns}
                  renderItem={renderItem}
                  refreshControl={_refreshControl()}
                  contentContainerStyle={{ paddingBottom: 72 }}
                  keyExtractor={(item, index) => (item?.canteen_id).toString()}
                />
              </View>
              <CartFooter />
            </React.Fragment>
          )}
          {isFocused && <BackButton isRoot={true} />}
        </React.Fragment>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f3',
  },
  mainContainer: {
    flex: 1,
    margin: 4,
  },
  countersContainer: {
    flex: 1,
    borderRadius: 8,
    padding: 8,
    margin: 4,
  },
  recommendedContainer: {
    // flex: 1,
    borderRadius: 8,
    padding: 8,
    margin: 4,
  },
  optionsContainer: {
    borderRadius: 8,
    padding: 8,
    margin: 4,
  },
  slideContainer: {
    flex: 1,
    height: 144,
    margin: 4,
    borderRadius: 8,
    backgroundColor: '#ffffff',
  },
  slide: {
    backgroundColor: 'rgba(20,20,200,0.3)',
    height: 200,
    width: '100%',
  },
  br6: {
    borderWidth: 1,
    borderColor: '#f1f1f3',
    borderBottomEndRadius: 6,
    borderBottomStartRadius: 6,
  },
  optionBr6: {
    borderBottomEndRadius: 6,
    borderBottomStartRadius: 6,
  },
  item: {
    flex: 1,
    marginVertical: 4,
    paddingHorizontal: 4,
  },
  option: {
    flex: 1,
    marginVertical: 4,
    padding: 8,
    paddingHorizontal: 8,
    // flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
    backgroundColor: '#ffffff',
    borderRadius: 4,
  },
  coverImage: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: '#ffffff',
  },
  ribbon: {
    position: 'absolute',
    top: 0,
    left: 0,
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderTopLeftRadius: 6,
  },
});

export default Home;
